<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-4 mt-4">
        <table class="w-full leading-normal text-blue-dark" style="border: solid 1px #dedede;">
          <thead class="bg-gray-pale">
          <tr class="bg-gray-pale">
            <th class="px-2 py-1">#</th>
            <th class="px-2 py-1">Name</th>
          </tr>
          </thead>
          <tbody>
          <tr style="border: solid 1px #dedede;" v-for="(document, idx) in documents"
              class="cursor-pointer hover:bg-gray-pale hover:font-bold"
              @click="view(document)"
              :key="idx">
            <td class="px-2 py-1">
                 <span class="text-gray text-xs">
                   {{(idx + 1)}}
                 </span>
            </td>
            <td class="px-2 py-1">
                 <span class="text-gray text-xs text-capitalize">
                   {{cleanEntityType(document.name.toLowerCase())}}
                 </span>
            </td>
          </tr>
          <tr v-if="documents.length === 0">
            <td colspan="12" class="bg-inertgrey text-center py-1">
              <span class="text-sm">No results found</span>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="grid grid-cols-12 gap-4" v-if="documents.length < 2">
          <div class="col-span-12">
            <p class="alert alert-success">
              <b>Note:</b> Documents are still being migrated to EDMS be patient they will all reflect here within the next 15mins.
            </p>
          </div>
        </div>
      </div>
      <div class="col-span-8 mt-4">
        <div class="grid grid-cols-12 gap-4">
          <div class="mx-auto">
            <span class="lds-ring" v-if="loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </span>
          </div>
          <div class="col-span-12">
            <EDMSDocument class="w-full border border-gray" ref="edmsFile" :file="getEDMSFile"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useBusinessRegistryStore } from "@/stores/business-registry";
import { useNetworkStore } from "@/stores/network";
import { useToast } from "@/composables";
import EDMSDocument from "@/domains/home/services/registry/business/document/EDMSDocument.vue";

defineProps<{ documents: any[] }>();

const registryStore = useBusinessRegistryStore();
const networkStore = useNetworkStore();
const { errorToast } = useToast();

const edmsFile = ref<InstanceType<typeof EDMSDocument> | null>(null);
const loading = ref(false);

const getEDMSFile = computed(() => registryStore.edms_file);

const cleanEntityType = (name: string) => {
  let n = name.replaceAll("_", " ");
  return n.charAt(0).toUpperCase() + n.slice(1);
};

const view = (document: any) => {
  let data = { documentHandle: document.base64String, overlay: "" };
  loading.value = true;
  registryStore.fetchSocietyEDMSFile(data);
};

watch(() => registryStore.edms_file, () => {
  loading.value = false;
});

watch(() => registryStore.error, () => {
  loading.value = false;
  errorToast("Error", "Failed to get document");
});

watch(() => networkStore.network_status, () => {
  loading.value = false;
  errorToast("Document Error", "Document loading times out");
});
</script>

